(function() {
    "use strict";

    angular.module("sempraWebapp").component("topupsTransactions", {
        templateUrl: "app/transactions/topups/topupsTransactions.html",
        controller: topupsTransactionsController,
        bindings: {
            email: "<"
        },
        controllerAs: "vm"
    });

    function topupsTransactionsController(transactionsActions, $translate, $timeout) {
        var vm = this;

        vm.$onInit = function() {
            refreshTopups();
        };

        vm.$onChanges = function() {
            $timeout(function() {
                refreshTopups();
            }, 750);
        }

        // DEFAULT DATE
        var currentYear = new Date().getFullYear();
        vm.topupsFrom = new Date(currentYear, 0, 1, 0, 0, 0, 0);
        vm.topupsTo = new Date();

        // GRID CONFIIG
        vm.topupsTransactionOrderBy = "companyName";
        vm.topupsTransactionOrder = "desc";
        vm.topupsTransactionPage = 1;
        vm.topupsTransactionTotal = 0;
        vm.topupsTransactionPageSize = 10;
        vm.topupsTransactionPageOptions = [10, 20];
        vm.selectedtopupsTransaction = [];
        vm.pagerTranslations = {
            page: $translate.instant("GRID_PAGER_PAGE"),
            rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
            of: $translate.instant("GRID_PAGER_PAGE_OF")
        };

        vm.sortChanged = function(order) {
            var orderQuery = getOrderObject(order);
            vm.topupsTransactionOrderBy = orderQuery.orderBy;
            vm.topupsTransactionOrder = orderQuery.order;
            refreshTopups();
        };

        vm.pageChanged = function(page, limit) {
            vm.topupsTransactionPage = page;
            vm.topupsTransactionPageSize = limit;
            vm.sortChanged(vm.topupsTransactionOrderBy);
        };

        vm.search = function() {
            vm.topupsTransactionPage = 1;
            refreshTopups();
        };

        function refreshTopups() {
            var encodeEmail = encodeURIComponent(vm.email);
            vm.promise = transactionsActions
                .getTransactionsTopUps(
                    encodeEmail,
                    vm.topupsFrom.getTime(),
                    vm.topupsTo.getTime(),
                    vm.topupsTransactionPage - 1,
                    vm.topupsTransactionPageSize,
                    vm.topupsTransactionOrderBy,
                    vm.topupsTransactionOrder
                )
                .then(function(data) {
                    vm.topups = (data.content.length === 0) ? [{companyName: $translate.instant("NOTHING_TO_DISPLAY")}] : data.content;
                    vm.topupsTransactionTotal = data.totalElements;
                });
        }

        function getOrderObject(order) {
            var result = {
                order: "asc",
                orderBy: order
            };

            if (order.indexOf("-") > -1) {
                result.order = "desc";
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();
